export default function initDemoEngine() {
  window.demo = {
    async run(actions = []) {
      for (const action of actions) {
        await this.execute(action);

        // 👇 smarter pacing
        if (action.type === "message") {
          await this.wait(1200);
        } else {
          await this.wait(600);
        }
      }
    },

    async execute(action) {
      switch (action.type) {
        case "navigate":
          await this.navigate(action);
          break;
        case "message":
          this.showMessage(action.text);
          break;
        case "set":
          //   await this.waitForPath(action.path);
          this.setValue(action.path, action.value);
          break;
        case "guide_field":
          this.guideField(action.field, action.text);
          break;

        case "guide_next":
          this.guideNext(action.text);
          break;
        case "select":
          this.selectRadio(action.field, action.value);
          break;
        case "highlight":
          this.highlight(action.field);
          break;
        case "click":
          this.click(action.selector);
          break;
        case "type":
          await window.demo.type(action.field, action.value);
          break;

        case "guide_input":
          this.guideInput(action.field, action.text);
          break;
        case "next":
          this.next();
          break;

        case "prev":
          this.prev();
          break;

        case "click_by_text":
          this.clickByText(action.text);
          break;
        case "highlight_next":
          this.highlightNextButton();
          break;
      }
    },
    showGuide(el, text) {
      if (window.__DEMO_GUIDE__) {
        window.__DEMO_GUIDE__.show(el, text);
      }
    },
    guideNext(text) {
      const btn = this.findNextButton();
      if (btn) {
        this.showGuide(btn, text);
      }
    },
    guideField(field, text) {
      const root = window.__ACTIVE_FORM__?.$el;
      if (!root) return;

      const groups = root.querySelectorAll('[role="radiogroup"]');

      for (const group of groups) {
        const legend = group.querySelector("legend");

        if (legend && legend.innerText.toLowerCase().includes(field.replace("_", " "))) {
          this.showGuide(group, text);
          return;
        }
      }
    },
    guideInput(field, text) {
      const input = this.findInputByField(field);
      if (input) {
        this.showGuide(input, text);
      }
    },
    async type(field, value) {
      const input = this.findInputByField(field);

      if (!input) {
        console.warn("Input not found:", field);
        return;
      }

      input.focus();

      input.value = "";

      for (let i = 0; i < value.length; i++) {
        input.value += value[i];

        input.dispatchEvent(new Event("input", { bubbles: true }));

        await this.wait(80); // typing speed
      }

      console.log("TYPED:", field, value);
    },
    findInputByField(field) {
      const root = window.__ACTIVE_FORM__?.$el;
      if (!root) return null;

      const inputs = root.querySelectorAll("input");

      for (const input of inputs) {
        const label = input.closest(".v-input")?.querySelector("label");

        if (
          label &&
          label.innerText.toLowerCase().includes(
            field
              .split(".")
              .pop()
              .replace("_", " ")
          )
        ) {
          return input;
        }
      }

      return null;
    },
    showMessage(text) {
      console.log("AI:", text);

      // ✅ use toast instead of chat
      if (window.showDemoToast) {
        window.showDemoToast(text);
      }
    },
    findFieldComponent(field) {
      const root = window.__ACTIVE_FORM__;
      if (!root) return null;

      const stack = [...root.$children];

      while (stack.length) {
        const comp = stack.pop();

        // 🔥 KEY: check if component is bound to this field
        if (comp.$vnode && comp.$vnode.data && comp.$vnode.data.model && comp.$vnode.data.model.expression === field) {
          return comp;
        }

        // fallback: check props
        if (comp.$attrs && comp.$attrs.label) {
          if (comp.$attrs.label.toLowerCase().includes(field.replace("_", " "))) {
            return comp;
          }
        }

        if (comp.$children) {
          stack.push(...comp.$children);
        }
      }

      return null;
    },
    highlight(field) {
      const root = window.__ACTIVE_FORM__?.$el;
      if (!root) return;

      // find ANY radio inside this field (we use first match)
      const radio = root.querySelector(`input[type="radio"]`);

      if (!radio) {
        console.warn("No radio found");
        return;
      }

      // 🔥 go up to radiogroup container
      const group = radio.closest('[role="radiogroup"]');

      if (!group) {
        console.warn("Radiogroup not found");
        return;
      }

      group.classList.add("demo-highlight");

      group.scrollIntoView({ behavior: "smooth", block: "center" });

      setTimeout(() => {
        group.classList.remove("demo-highlight");
      }, 2000);
    },
    waitForPath(path, timeout = 5000) {
      return new Promise(resolve => {
        const start = Date.now();

        const check = () => {
          let root = null;

          if (window.__ACTIVE_FORM__ && window.__ACTIVE_FORM__.model) {
            root = window.__ACTIVE_FORM__.model;
          } else {
            return requestAnimationFrame(check);
          }

          const keys = path.split(".");
          let obj = root;

          for (let i = 0; i < keys.length; i++) {
            obj = obj[keys[i]];
            if (!obj) break;
          }

          if (obj !== undefined) {
            resolve(true);
            return;
          }

          if (Date.now() - start > timeout) {
            console.warn("Path not ready:", path);
            resolve(false);
            return;
          }

          requestAnimationFrame(check);
        };

        check();
      });
    },
    select(field, value) {
      const comp = this.findFieldComponent(field);

      if (!comp) {
        console.warn("Component not found:", field);
        return;
      }

      // 🔥 TRY COMMON VUETIFY PATTERNS

      if (comp.$emit) {
        comp.$emit("input", value);
      }

      if (comp.internalValue !== undefined) {
        comp.internalValue = value;
      }

      if (comp.value !== undefined) {
        comp.value = value;
      }
    },
    selectRadio(field, value) {
      // find all radio inputs
      const radios = document.querySelectorAll(`input[type="radio"][value="${value}"]`);

      if (!radios.length) {
        console.warn("Radio not found:", value);
        return;
      }

      // pick the visible one (important if multiple forms exist)
      const radio = Array.from(radios).find(r => r.offsetParent !== null);

      if (!radio) {
        console.warn("Visible radio not found:", value);
        return;
      }

      // 🔥 click it like a real user
      radio.click();

      console.log("RADIO SELECTED:", value);
    },
    findNextButton() {
      const buttons = document.querySelectorAll("button, .v-btn");

      for (const btn of buttons) {
        const text = (btn.innerText || "").toLowerCase().trim();

        if (text.includes("next") || text.includes("continue") || text.includes("save")) {
          return btn;
        }
      }

      return null;
    },
    highlightNextButton() {
      const btn = this.findNextButton();

      if (!btn) {
        console.warn("Next button not found for highlight");
        return;
      }

      btn.classList.add("demo-highlight");

      btn.scrollIntoView({ behavior: "smooth", block: "center" });

      setTimeout(() => {
        btn.classList.remove("demo-highlight");
      }, 1500);
    },
    next() {
      const route = window.router?.currentRoute?.path || "";

      // ✅ ONLY run in shipment wizard
      if (!route.includes("shipment")) {
        console.warn("Not in shipment wizard, skipping next()");
        return;
      }

      // try specific wizard button first
      const btn = document.querySelector('[data-action="next"]') || this.findNextButton();

      if (btn) {
        btn.click();
        console.log("NEXT CLICKED");
      } else {
        console.warn("Next button not found");
      }
    },
    prev() {
      this.clickByText("back");
    },
    waitForForm(timeout = 5000) {
      return new Promise(resolve => {
        const start = Date.now();

        const check = () => {
          if (window.__ACTIVE_FORM__) {
            resolve(true);
            return;
          }

          if (Date.now() - start > timeout) {
            resolve(false);
            return;
          }

          requestAnimationFrame(check);
        };

        check();
      });
    },
    clickByText(text) {
      const buttons = document.querySelectorAll("button, .v-btn");

      for (const btn of buttons) {
        if (btn.innerText.toLowerCase().includes(text.toLowerCase())) {
          btn.click();
          return;
        }
      }
    },
    async navigate(action) {
      if (window.router) {
        // await window.router.push(route);
        window.addResentTab({
          permitted: true,
          link: action.route,
          text: action.label
        });
      } else {
        window.location.href = action.route;
      }

      // allow Vue + async schema to start
      await this.wait(300);

      // wait until form is mounted
      await this.waitForForm();

      // 🔥 CRITICAL: stabilization delay (your idea)
      await this.wait(1000);
    },
    findPath(obj, targetKey, currentPath = "") {
      if (!obj || typeof obj !== "object") return null;

      for (const key in obj) {
        const newPath = currentPath ? `${currentPath}.${key}` : key;

        if (key === targetKey) {
          return newPath;
        }

        if (typeof obj[key] === "object") {
          const result = this.findPath(obj[key], targetKey, newPath);
          if (result) return result;
        }
      }

      return null;
    },
    resolvePath(path) {
      const root = window.__ACTIVE_FORM__?.model;
      if (!root) return path;

      const keys = path.split(".");
      const lastKey = keys[keys.length - 1];

      // try direct path first
      let obj = root;
      let valid = true;

      for (let i = 0; i < keys.length - 1; i++) {
        obj = obj[keys[i]];
        if (!obj) {
          valid = false;
          break;
        }
      }

      if (valid) return path;

      // 🔥 fallback: find by key anywhere
      const found = this.findPath(root, lastKey);

      if (found) {
        console.log("PATH FIXED:", path, "→", found);
        return found;
      }

      return path;
    },
    setValue(path, value) {
      if (!window.__ACTIVE_FORM__) return;

      // 🔥 resolve path dynamically
      path = this.resolvePath(path);

      const keys = path.split(".");
      let obj = window.__ACTIVE_FORM__.model;

      for (let i = 0; i < keys.length - 1; i++) {
        obj = obj[keys[i]];
        if (!obj) return;
      }

      const lastKey = keys[keys.length - 1];

      window.__ACTIVE_FORM__.$set(obj, lastKey, value);

      console.log("SET:", path, value);
    },

    click(selector) {
      const el = document.querySelector(selector);
      if (el) el.click();
    },

    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  };
  window.getUIState = () => {
    try {
      const route = window.router?.currentRoute?.path || null;

      const formModel = window.__ACTIVE_FORM__?.model || null;

      return {
        route,
        form: formModel
      };
    } catch (e) {
      console.warn("getUIState error:", e);
      return {
        route: null,
        form: null
      };
    }
  };
}
